module.exports = __webpack_public_path__ + "img/96ne.d76e1491.svg";